function timeAgo(epochTimestamp) {
    const now = new Date().getTime();
    const difference = now - epochTimestamp;
    const seconds = Math.floor(difference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);
    if (epochTimestamp === 0) {
        return '';
    }
    if (seconds <= 0) {
        return `1 second ago`;
    }
    if (seconds < 60) {
        return `${seconds} seconds ago`;
    } else if (minutes < 60) {
        return `${minutes} minutes ago`;
    } else if (hours < 24) {
        return `${hours} hours ago`;
    } else if (hours < 48) {
        const date = new Date(epochTimestamp);
        return `Yesterday at ${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    } else if (days < 7) {
        const date = new Date(epochTimestamp);
        return `${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    } else if (days < 30) {
        const date = new Date(epochTimestamp);
        return `${date.toLocaleString('default', { weekday: 'long' })} at ${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    } else if (days < 365) {
        const date = new Date(epochTimestamp);
        return `${date.toLocaleString('default', { month: 'long' })} ${date.getDate()} at ${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    } else {
        const date = new Date(epochTimestamp);
        return `${date.toLocaleString('default', { month: 'long' })} ${date.getDate()}, ${date.getFullYear()} at ${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    }
}

function formatTime(seconds) {
    let minutes = Math.floor(seconds / 60);
    let remainingSeconds = seconds % 60;

    // Adding leading zero if minutes or seconds are less than 10
    minutes = minutes < 10 ? '0' + minutes : minutes;
    remainingSeconds = remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds;

    return minutes + ":" + remainingSeconds;
}

//function that get epoch time and return a string with the time in format hh:mm:ss
function epochToClock(epochTime) {
    const date = new Date(epochTime);
    const options = {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    };

    // Return the formatted time
    return date.toLocaleTimeString([], options);
}

exports.formatTime = formatTime;
exports.timeAgo = timeAgo;
exports.epochToClock = epochToClock;